import { createSvgIcon } from "@material-ui/core/utils";
import React from "react";

export const CopyIcon = createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M9 8L19 8C19.5523 8 20 8.44772 20 9L20 19C20 19.5523 19.5523 20 19 20L9 20C8.44771 20 8 19.5523 8 19L8 9C8 8.44772 8.44772 8 9 8ZM6 9C6 7.34315 7.34314 6 9 6L19 6C20.6569 6 22 7.34315 22 9L22 19C22 20.6569 20.6569 22 19 22L9 22C7.34315 22 6 20.6569 6 19L6 9ZM2 15C2 15.5523 2.44771 16 3 16C3.55228 16 4 15.5523 4 15L4 7C4 5.34315 5.34315 4 7 4L15 4C15.5523 4 16 3.55229 16 3C16 2.44772 15.5523 2 15 2L7 2C4.23858 2 2 4.23858 2 7L2 15Z"
    fill="currentColor"
  />,
  "CopyIcon"
);
